import React, { KeyboardEvent, ReactNode } from 'react';
import ReactModal from 'react-modal';
import CloseIcon from '../../../public/static/icons/close-rounded.svg';

import styles from './index.module.scss';

type PopupType = ReactModal.Props & {
  children: ReactNode;
  isOpen?: boolean;
  onRequestClose?: () => void;
  className?: string;
  overlayClassName?: string;
  contentClassName?: string;
  bodyClassName?: string;
  closeButton?: ReactNode;
};

const Popup = ({
  children,
  isOpen = false,
  onRequestClose = () => {},
  className = '',
  overlayClassName = '',
  contentClassName = '',
  bodyClassName = '',
  closeButton = null,
  ...props
}: PopupType) => {
  const onKeyDown = (e: KeyboardEvent) => {
    // 'e.key' is empty in case of 'Space', using 'e.code' instead.
    if (e.code === 'Enter' || e.code === 'Space') {
      // Needs to prevent multiple firing of the action that may lead to side effects.
      e.preventDefault();
      e.stopPropagation();
      onRequestClose();
    }
  };

  const closeButtonElement: ReactNode = (closeButton as ReactNode) ?? (
    <button className={styles['close']} onClick={onRequestClose} onKeyDown={onKeyDown}>
      <CloseIcon aria-label="Close overlay" />
    </button>
  );

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName={`${styles['fade']} ${styles['modal-backdrop']} ${styles['in']} ${overlayClassName}`}
      className={`${styles['modal-dialog']} ${className}`}
      bodyOpenClassName={styles['modal-open']}
      appElement={
        typeof document !== 'undefined'
          ? (document.getElementById('__next') as HTMLElement)
          : undefined
      }
      {...props}
    >
      <div className={contentClassName}>
        {closeButtonElement}
        <div className={bodyClassName}>{children}</div>
      </div>
    </ReactModal>
  );
};

export default Popup;
